import { StructureBuilder } from "sanity/structure";
import type { ComponentType, ReactNode } from "react";

type ContentType = {
  name: string;
  title?: string | undefined;
  icon?: ReactNode | ComponentType;
};

export const generateChildren = (
  S: StructureBuilder,
  contentTypes: Record<string, ContentType>
) =>
  Object.values(contentTypes).map((item) =>
    S.listItem()
      .title(item.title || item.name)
      .icon(item.icon)
      .child(
        S.document()
          .schemaType(item.name)
          .documentId(item.name)
          .title(item.title || item.name)
      )
  );
